module.exports = __webpack_public_path__ + "static/slide-1_website_en-7c894a19d8327a095c703c7681d1c9da.jpg";